import React from 'react'
import { LoadingAnimation } from 'src/admin/components/Loader'
import { AuthConsumer } from '../AuthProvider'

const LogoutCallback = () => (
  <AuthConsumer>
    {({ signoutRedirectCallback }) => {
      signoutRedirectCallback()
      return <LoadingAnimation />
    }}
  </AuthConsumer>
)

export default LogoutCallback
